import { render, staticRenderFns } from "./devdetail.vue?vue&type=template&id=c8e9d25e&scoped=true"
import script from "./devdetail.vue?vue&type=script&lang=js"
export * from "./devdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e9d25e",
  null
  
)

export default component.exports